/**
 * GroupProfileValidationStateService
 *
 * Service for managing validation state and errors across GroupProfile controllers.
 * Provides centralized validation state management and error messaging.
 */

export const GroupProfileValidationStateService = {
  validationErrors: new Map(),
  submissionAttempted: false,

  setSubmissionAttempted(attempted) {
    this.submissionAttempted = attempted;
  },

  isSubmissionAttempted() {
    return this.submissionAttempted;
  },

  addError(key, message) {
    this.validationErrors.set(key, message);
  },

  removeError(key) {
    this.validationErrors.delete(key);
  },

  clearAllErrors() {
    this.validationErrors.clear();
  },

  hasErrors() {
    return this.validationErrors.size > 0;
  },

  getErrors() {
    return Array.from(this.validationErrors.values());
  },

  getError(key) {
    return this.validationErrors.get(key);
  },

  reset() {
    this.clearAllErrors();
    this.submissionAttempted = false;
  },

  dispatchValidationStateChange(element) {
    const event = new CustomEvent("group-profile:validation-state-changed", {
      bubbles: true,
      cancelable: true,
      detail: {
        hasErrors: this.hasErrors(),
        errors: this.getErrors(),
        submissionAttempted: this.submissionAttempted,
      },
    });
    element.dispatchEvent(event);
  },
};

export default GroupProfileValidationStateService;
